import api from '../..';

export default (params) => {
  let url = '/tourclient/api/tour/search/tours?';
  Object.entries(params)
    .forEach(([key, value]) => {
      if (!value) {
        return;
      }
      if (Array.isArray(value)) {
        value.forEach((i) => {
          url += `${key}=${i}&`;
        });
      } else {
        url += `${key}=${value}&`;
      }
    });
  return api.get(url, {
    formatting: true,
  });
};
